<template>
	<a-modal title="批量搜索" :visible="show" @ok="confirm" @cancel="close">
		<a-form-model ref="ipForm" :model="form" :rules="rules" :colon="false">
			<a-form-model-item
				labelAlign="left"
				label="资源池IP地址"
				prop="ipList"
				required
				class="pool"
			>
				<a-textarea
					v-model="form.ipList"
					:rows="4"
					placeholder="请输入IP地址，可以输入多个，用英文逗号隔开"
					allow-clear
				/>
			</a-form-model-item>
		</a-form-model>
	</a-modal>
</template>

<script>
export default {
	name: "BatchSelect",
	data() {
		return {
			form: {
				ipList: "",
			},
			rules: {
				ipList: [
					{ required: true, message: "请输入IP地址" },
					{ pattern: /^[0-9,.]+$/, message: "请按格式输入IP地址" },
				],
			},
			show: false,
		};
	},
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		visible(val) {
			this.show = val;
		},
	},
	methods: {
		confirm() {
			this.$refs.ipForm.validate(valid => {
				if (valid) {
					const res = this.form.ipList.split(",");
					// console.log(res)
					this.$emit("confirm", res);
					this.close();
				}
			});
		},
		/**
		 * @description: 关闭弹窗
		 */
		close() {
			this.$refs.ipForm.resetFields();
			this.$emit("update:visible", false);
		},
	},
};
</script>

<style lang="less" scoped></style>
